import Reveal from "@/components/base/Reveal";
import SectionHeading from "@/pages/home/components/SectionHeading";
import { relationNodes, relationSummary } from "@/mocks/homeData";

export default function Relation() {
  return (
    <section id="relation" className="w-full border-b border-background-200 bg-background-100">
      <div className="mx-auto w-full max-w-[1180px] px-4 py-14 md:px-6 md:py-20">
        <Reveal>
          <SectionHeading
            eyebrow="RELATION LINES"
            title="关系脉络：从起点一路连到空白节点"
            description="把主角、配角、账号与见证者按连接顺序排成一条链，每一环都注明依据；连不上的地方，就直接标成空白。"
          />
        </Reveal>

        <div className="mt-10 grid grid-cols-1 gap-10 lg:grid-cols-12 lg:gap-12">
          <div className="lg:col-span-7">
            <ol className="relative">
              {relationNodes.map((node, index) => (
                <Reveal key={node.id} delay={index * 70}>
                  <li className="relative flex gap-4 pb-7 last:pb-0 md:gap-6">
                    <div className="relative flex flex-col items-center">
                      <span
                        className={`mt-1 flex h-8 w-8 flex-none items-center justify-center rounded-full border text-xs font-bold ${
                          node.role === "空白节点"
                            ? "border-accent-300 bg-accent-50 text-accent-700"
                            : "border-primary-300 bg-primary-50 text-primary-700"
                        }`}
                      >
                        {index + 1}
                      </span>
                      {index !== relationNodes.length - 1 && (
                        <span className="mt-2 w-px flex-1 bg-background-300" />
                      )}
                    </div>

                    <div className="flex-1 rounded-lg border border-background-200 bg-background-50 p-4 md:p-5">
                      <div className="flex flex-wrap items-center gap-x-3 gap-y-2">
                        <span className="font-heading text-base font-bold text-foreground-950">{node.label}</span>
                        <span className="rounded-full bg-secondary-100 px-2.5 py-0.5 font-label text-[11px] text-secondary-900">
                          {node.role}
                        </span>
                      </div>
                      <div className="mt-3 flex flex-wrap items-center gap-2 font-label text-sm text-foreground-700">
                        <span className="rounded-md border border-background-200 px-2 py-1 text-xs text-foreground-600">
                          {node.edge}
                        </span>
                        <i className="ri-arrow-right-line text-foreground-400" />
                        <span className="font-medium text-foreground-900">{node.target}</span>
                      </div>
                      <p className="mt-3 text-xs leading-relaxed text-foreground-600 md:text-[13px]">{node.note}</p>
                    </div>
                  </li>
                </Reveal>
              ))}
            </ol>
          </div>

          <div className="lg:col-span-5">
            <div className="flex flex-col gap-3">
              {relationSummary.map((item, index) => (
                <Reveal key={item.id} delay={index * 80}>
                  <article className="rounded-lg border border-background-200 bg-background-50 p-5">
                    <h4 className="font-heading text-base font-bold text-foreground-950">{item.title}</h4>
                    <p className="mt-2 text-sm leading-relaxed text-foreground-600">{item.summary}</p>
                  </article>
                </Reveal>
              ))}

              <Reveal delay={240}>
                <div className="rounded-lg border border-accent-200 bg-accent-50 p-5">
                  <div className="flex items-center gap-2 font-label text-xs tracking-wide text-accent-700">
                    <i className="ri-error-warning-line text-sm" />
                    待补充节点
                  </div>
                  <p className="mt-2 text-sm leading-relaxed text-accent-900/80">
                    K先生所在的位置目前没有任何独立信源，如果你手上有能对上时间线的公开记录，可以在下方讨论区补充。
                  </p>
                  <a
                    href="#discussion"
                    className="mt-3 inline-flex items-center gap-1 font-label text-xs text-accent-700 transition-colors duration-200 hover:text-accent-600"
                  >
                    前往讨论区
                    <i className="ri-arrow-right-line text-sm" />
                  </a>
                </div>
              </Reveal>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}